var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.footer},[_c('div',{class:_vm.$style.footerInner},[_c('br'),_c('p',{staticClass:"mb-0"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" | ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }